<template>
  <nuttrema-layout-form-standard :edit="edit" :theme="theme" :saveError="InstanceDetails.saveError">
    <template slot="center">
      <el-form
        :ref="formRef"
        :rules="rules"
        :model="formData"
        label-width="20em">

        <section class="is-info-card">
          <h4 class="section-title">{{ $t('label.instance_owner') }}</h4>
          <div class="section-items">
            <professional-info-small-card
               class="is-in-section"
               style="margin-left: 19.5em; margin-bottom: 1em"
              :reactive="false"
              :personDetails="_get(InstanceDetails, 'data.Owner')">
            </professional-info-small-card>

            <el-form-item :label="$t('label.phone')">
              <el-col :span="18">
                <el-input :value="_get(InstanceDetails, 'data.Owner.phone') | phone" :disabled="true"></el-input>
              </el-col>
            </el-form-item>
          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.general_information') }}</h4>
          <div class="section-items">
            <el-form-item :label="$t('label.name')" prop="name">
              <el-col :span="16">
                <el-input v-model="formData.name" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.subdomain')" prop="subdomain">
              <el-col :span="18">
                <el-input v-model="formData.subdomain" :disabled="true"></el-input>
              </el-col>
              <el-col :span="24">
                <p class="el-form-item__help" v-html="_markdown.renderInline($t('label.subdomain_example', { subdomain: formData.subdomain, }))"></p>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.last_active_plan')" prop="last_active_plan">
              <el-col :span="18">
                <el-input :value="_get(InstanceDetails, 'data.LastActivePlan.name')" :disabled="true">
                  <template slot="prepend">{{ _get(InstanceDetails, 'data.LastActivePlan.SubscriptionPlanType.name') }}</template>
                </el-input>
              </el-col>
              <el-col :span="24">
                <p class="el-form-item__help">{{ _get(InstanceDetails, 'data.LastActivePlan.outline') }}<br><strong>{{ $t('label.subscription_end_date', { end_date: moment(_get(InstanceDetails, 'data.LastActivePlan.end_date')).format('ll') }) }}</strong></p>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.instance_type')" prop="instance_type">
              <el-col :span="18">
                <el-input v-model="formData.instance_type" :disabled="true"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.status')" prop="status">
              <el-col :span="12">
                <el-input :value="$t(`label.${formData.status}`)" :disabled="true" :suffix-icon="formData.status === 'active' ? 'far fa-check' : 'far fa-times'"></el-input>
              </el-col>
            </el-form-item>
          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.regional_settings') }}</h4>

          <el-form-item :label="$t('label.preffered_language')">
            <el-col  class="el-col--min-17em" :span="6">
              <el-select v-model="formData.InstanceData.regional_and_language_settings_default_language.value" class="w-100" :disabled="!edit">
                <el-option v-for="language in _get(RegionalAndLanguageAll, 'data.Languages', [])"
                  :label="language.native_name"
                  :value="language.code"
                  :key="language.id">
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>

          <el-form-item :label="$t('label.time_zone')">
            <el-col class="el-col--min-17em" :span="8">
              <el-cascader
                 v-if="_isArray(formData.InstanceData.regional_and_language_settings_default_time_zone.value)"
                 v-model="formData.InstanceData.regional_and_language_settings_default_time_zone.value"
                 class="w-100"
                :disabled="!edit"
                :clearable="edit"
                :filterable="true"
                :options="_get(RegionalAndLanguageAll, 'data.TimeZones', [])"
                :props="{ label: 'title', value: 'name', children: 'Zones' }"
                :show-all-levels="true">
              </el-cascader>
              <el-input
                 v-else
                 v-model="formData.InstanceData.regional_and_language_settings_default_time_zone.value"
                :disabled="!edit">
              </el-input>
            </el-col>
          </el-form-item>

          <el-form-item :label="$t('label.measurement_system')">
            <el-col class="el-col--min-17em" :span="6">
              <el-select v-model="formData.InstanceData.regional_and_language_settings_default_measurement_system.value" class="w-100" :disabled="!edit">
                <el-option v-for="measurementSystem in _get(RegionalAndLanguageAll, 'data.MeasurementSystems', [])"
                  :label="measurementSystem.name"
                  :value="measurementSystem.code"
                  :key="measurementSystem.id">
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.company_information') }}</h4>

          <div class="section-items">
            <el-form-item :label="$t('label.company_name')" prop="company_name">
              <el-col :span="14">
                <el-input v-model="formData.InstanceData.company_information_company_name.value" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.vat_number')" prop="vat_number">
              <el-col :span="8">
                <el-input v-model="formData.InstanceData.company_information_vat_number.value" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.street')" prop="street">
              <el-col :span="14">
                  <el-input v-model="formData.InstanceData.company_information_street.value" :placeholder="$t('label.street')" :disabled="!edit"></el-input>
              </el-col>
              <el-col :span="6" :offset="1">
                  <el-input v-model="formData.InstanceData.company_information_house_no.value" :placeholder="$t('label.house_no')" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.city')" prop="city">
              <el-col :span="14">
                <el-input v-model="formData.InstanceData.company_information_city.value" :placeholder="$t('label.city')" :disabled="!edit"></el-input>
              </el-col>
              <el-col :span="6" :offset="1">
                  <el-input v-model="formData.InstanceData.company_information_zip.value" :placeholder="$t('label.zip')" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.country')">
              <el-col class="el-col--min-17em" :span="8">
                <el-cascader
                   v-model="formData.region_id"
                   class="w-100"
                  :disabled="!edit"
                  :clearable="edit"
                  :filterable="true"
                  :options="_get(RegionalAndLanguageAll, 'data.Regions', [])"
                  :props="{ label: 'title', value: 'id', children: 'SubRegions' }"
                  :show-all-levels="false">
                </el-cascader>
              </el-col>
            </el-form-item>
          </div>
        </section>

      </el-form>
    </template>

    <template slot="footer">
      <nav class="footer-row">

        <el-button
           size="small"
           type="primary"
          :loading="isSaving"
          :disabled="!isDataChanged"
          @click="submitForm">{{ $t('label.save_changes') }}</el-button>

        <el-button
           type="text"
           size="small"
          @click="cancelChanges">
          <span v-if="showDoneButton">{{ $t('label.done') }}</span>
          <span v-else>{{ $t('label.cancel') }}</span>
        </el-button>

      </nav>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
import { assign, get, isNil, isEmpty, set, pickBy, last, includes, cloneDeep, merge, has } from 'lodash';

import moment from 'moment';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import ProfessionalInfoSmallCard from 'components/ui/card/professional-info-small-card';

export default {
  name: 'form-instance-details',
  mixins: [FormStandardBehavior],
  props: {
    InstanceDetails: {
      type: Object,
      required: false,
    },
    RegionalAndLanguageAll: {
      type: Object,
      required: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    ProfessionalInfoSmallCard,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        name: null,
        status: null,
        subdomain: null,
        instanceType: null,
        region_id: [],
        InstanceData: {
          regional_and_language_settings_default_time_zone: {
            section: 'regional_and_language_settings',
            key: 'default_time_zone',
            value: [],
          },
          regional_and_language_settings_default_language: {
            section: 'regional_and_language_settings',
            key: 'default_language',
            value: [],
          },
          regional_and_language_settings_default_measurement_system: {
            section: 'regional_and_language_settings',
            key: 'default_measurement_system',
            value: [],
          },
          company_information_company_name: {
            section: 'company_information',
            key: 'company_name',
            value: null,
          },
          company_information_vat_number: {
            section: 'company_information',
            key: 'vat_number',
            value: null,
          },
          company_information_street: {
            section: 'company_information',
            key: 'street',
            value: null,
          },
          company_information_house_no: {
            section: 'company_information',
            key: 'house_no',
            value: null,
          },
          company_information_city: {
            section: 'company_information',
            key: 'city',
            value: null,
          },
          company_information_zip: {
            section: 'company_information',
            key: 'zip',
            value: null,
          },
        },
      },
      rules: {
        name: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.name', true),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    moment,
    setFormData() {
      assign(this.formData, {
        name: get(this.InstanceDetails, 'data.name', null),
        region_id: get(this.InstanceDetails, 'data.region_id', null),
        status: get(this.InstanceDetails, 'data.status', 'draft'),
        subdomain: get(this.InstanceDetails, 'data.subdomain', null),
        instance_type: get(this.InstanceDetails, 'data.InstanceType.name', null),
      });

      merge(this.formData.InstanceData, get(this.InstanceDetails, 'data.InstanceData', {}));

      this.originalData = assign({}, this.formData);
    },
    getFormData() {
      const clone = cloneDeep(this.formData);

      const data = pickBy(clone, (field, key) => includes(['name', 'region_id', 'InstanceData'], key) && (!isNil(field) || !isEmpty(field)));

      const timeZone = get(data, 'InstanceData.regional_and_language_settings_default_time_zone.value');
      if (timeZone) {
        set(data, 'InstanceData.regional_and_language_settings_default_time_zone.value', last(timeZone));
      }

      if (has(data, 'region_id')) data.region_id = last(data.region_id);

      return data;
    },
  },
  created() {
    this.stateData = this.InstanceDetails;
    this.formRef = 'form-instance-details';
    this.setFormData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/shared/instance-details/form-instance-details.vue